<template>
  <ol class="flex flex-col gap-2">
    <li v-for="domain in domains" :key="domain.name">
      <RouterLink
        class="@container bg-gray-100 hover:bg-gray-200 transition-colors no-underline rounded-lg px-4 py-3 flex gap-4 flex-col @lg:flex-row justify-between items-start @lg:items-center"
        :class="{
          'opacity-50 pointer-events-none': !isCMPEditable(domain),
        }"
        :to="{
          name: 'Domain Overview',
          params: { domain: domain.name },
        }"
      >
        <div class="flex flex-col @3xl:flex-row gap-2">
          <div class="text-gray-800">
            <span class="font-bold">{{ domain.name }}</span>
            <span class="capitalize font-semibold">
              | {{ formatProductType(domain) }}
            </span>
          </div>
          <div
            v-if="!isCMPEditable(domain)"
            class="rounded-lg bg-orange-200 text-orange-900 font-semibold text-sm px-2 py-1"
          >
            Not eligible for content suggestions
          </div>
          <div
            v-else-if="!domain.vendor_approved && vendorSelected"
            class="rounded-lg bg-orange-200 text-orange-900 font-semibold text-sm px-2 py-1"
          >
            Not granted access
          </div>
        </div>
        <div v-if="isCMPEditable(domain) && vendorSelected" class="text-sm">
          <span class="text-gray-500">last updated: </span>
          <span class="text-gray-700 font-semibold">
            {{ formatLastOverrideUpdated(domain) }}
          </span>
        </div>
      </RouterLink>
    </li>
  </ol>
</template>

<script setup>
import { formatRelative, parseISO } from "date-fns";
import { storeToRefs } from "pinia";
import { computed } from "vue";
import useUserStore from "@/stores/user";

const userStore = useUserStore();
const { vendorKey } = storeToRefs(userStore);

defineProps({
  domains: { type: Array, required: true },
});

const vendorSelected = computed(() => {
  return vendorKey.value && vendorKey.value !== "all";
});

function formatLastOverrideUpdated(domainData) {
  try {
    return formatRelative(parseISO(domainData.last_cmp_dco_date), new Date());
  } catch (err) {
    return "Never";
  }
}

function formatProductType(domainData) {
  return domainData.product_type.replace("_", " ");
}

function isCMPEditable(domainData) {
  return domainData.product_type === "m1" || domainData.product_type === "m2";
}
</script>
